import Theme from './theme';
// eslint-disable-next-line no-restricted-syntax
import * as config from './config';
// eslint-disable-next-line no-restricted-syntax
import * as constants from './constants';

import { createFeatureToggleUtil } from '@shopee-user/shared-customization-logic';
import { FEATURE_TOGGLE_CONFIG } from './featureToggle';

const { isFeatureEnabled } = createFeatureToggleUtil({
  featureToggleConfig: FEATURE_TOGGLE_CONFIG,
});
export { isFeatureEnabled, Theme, config, constants };

// Types
export type { SupportedLocale } from './constants/customerServicesUrl';

// IVS
export {
  getIvsClientId,
  getLoginIvsEventType,
  getOneCredentialLoginIvsEventType,
} from './ivs/config';
export { IVS_BASE_URL, IVS_BASE_REGEX } from './constants/index';

// ThirdParty Auth
export { getShopeeOAuthConfig } from './thirdparty/config';

// Utils
export {
  hashPassword,
  getToCResetPasswordUrl,
  getNativeDeviceFingerprint,
  loginByPasswordWebViewLoginSuccessfully,
  getAvailableLoginMethodConfig,
  getChangeEmailHelpLink,
  getChangeEmailNativeVerificationLink,
  getChangePasswordHelpLink,
  getChangePasswordNativeVerificationLink,
  addOrChangePhoneExitHandling,
  addOrChangePasswordExitHandling,
  addOrChangeEmailExitHandling,
} from '@shopee-user/shared-customization-logic';
export { getNativeVersion } from './utils/version';
export {
  getBusinessUrl,
  getBusinessAuthRedirectUrl,
} from './utils/getBusinessUrl';
export {
  redirectWithToCNonce,
  redirectAfterOneCredentialDelink,
} from './utils/redirect';
export { getLoginRedirectionParameters } from './utils/authSource';
export { getWebThirdPartyClientId } from './utils/thirdPartyClientId';
export { getThirdPartyFlowTriggerUrl } from './utils/getUserLinkageTriggerUrl';

// Tracking Configs
export { getLoginPageTypeAndSchema } from './tracking/schemaConfig/login';
export { getOTPDialogPageTypeAndSchema } from './tracking/schemaConfig/otpDialog';
export { getOTPEnterVerificationPageTypeAndSchema } from './tracking/schemaConfig/otpEnterVerification';
export { getOTPSelectVerificationPageTypeAndSchema } from './tracking/schemaConfig/otpSelectVerification';
export { getResetPasswordPageTypeAndSchema } from './tracking/schemaConfig/resetPassword';
export { getSetNewPasswordPageTypeAndSchema } from './tracking/schemaConfig/setNewPassword';
export { getVerifyCurrentPasswordPageTypeAndSchema } from './tracking/schemaConfig/verifyCurrentPassword';
export { getMyAccountPageTypeAndSchema } from './tracking/schemaConfig/myAccount';
export { getMyStaffAccountListPageTypeAndSchema } from './tracking/schemaConfig/myStaffAccountList';
export { getStaffAccountDetailsPageTypeAndSchema } from './tracking/schemaConfig/staffAccountDetails';
export { getMerchantAccountSettingPageTypeAndSchema } from './tracking/schemaConfig/merchantAccountSetting';
export { getEnterNewPhonePageTypeAndSchema } from './tracking/schemaConfig/enterNewPhone';
export { getEnterNewEmailPageTypeAndSchema } from './tracking/schemaConfig/enterNewEmail';
export { getChangePhonePageTypeAndSchema } from './tracking/schemaConfig/userPhone';
export { getChangeEmailPageTypeAndSchema } from './tracking/schemaConfig/userEmail';
export {
  getAccountBindAccountBindingPageTypeAndSchema,
  getAccountBindCreateAccountPageTypeAndSchema,
  getAccountBindReclaimFailurePageTypeAndSchema,
  getAccountBindSetPasswordPageTypeAndSchema,
} from './tracking/schemaConfig/accountBind';
export {
  getAccountUpdateMethodSelectionPageTypeAndSchema,
  getAccountUpdateOverviewPageTypeAndSchema,
  getAccountUpdateSuccessPageTypeAndSchema,
} from './tracking/schemaConfig/accountUpdate';
export {
  getSignupPageTypeAndSchema,
  getSignupAccountPhoneAlreadyRegisteredPageTypeAndSchema,
  getSignupAccountEmailAlreadyRegisteredPageTypeAndSchema,
  getSignupSetPasswordPageTypeAndSchema,
  getSignupSuccessPageTypeAndSchema,
} from './tracking/schemaConfig/signup';
export {
  getBiometricPromptPageTypeAndSchema,
  getReloginBiometricsPageTypeAndSchema,
  getReloginPasswordPageTypeAndSchema,
} from './tracking/schemaConfig/biometrics';
export { getWhatsappAuthLinkPageTypeAndSchema } from './tracking/schemaConfig/whatsappAuthLink';
export {
  getOneCredentialDelinkInitPageTypeAndSchema,
  getOneCredentialDelinkSetupTobAccountPageTypeAndSchema,
  getOneCredentialDelinkSetupPasswordPageTypeAndSchema,
  getOneCredentialDelinkSuccessPageTypeAndSchema,
  getOneCredentialDelinkErrorPageTypeAndSchema,
} from './tracking/schemaConfig/oneCredentialDelink';
export { getThirdPartyAccountLinkagePageTypeAndSchema } from './tracking/schemaConfig/thirdPartyAccountLinkage';
export { getThirdPartyServicePageTypeAndSchema } from './tracking/schemaConfig/thirdPartyService';
export {
  getQuickLoginPromptPageTypeAndSchema,
  getReloginQuickLoginPageTypeAndSchema,
} from './tracking/schemaConfig/quickLogin';

// Form Configs
export {
  LOGIN_BY_PASSWORD_FORM_CONFIG,
  LOGIN_BY_OTP_FORM_CONFIG,
  BIOMETRICS_LOGIN_BY_PASSWORD_FORM_CONFIG,
  ONE_CREDENTIAL_DELINK_SET_PASSWORD_FORM_CONFIG,
} from '@shopee-user/shared-customization-logic';

// Biometrics
export { biometrics } from '@shopee-user/shared-customization-logic';

// No Cost Authentication
export { noCostAuthentication } from '@shopee-user/shared-customization-logic';

// AB Test
export * as abTest from './abtest';
